'use strict';

/* global yith_wcaf */

import { $ } from '../../../src/globals.js';

export default class YITH_WCAF_Admin_Tabs {
	// container
	$container = null;

	// tab anchors
	$tabAnchors = null;

	// tabs
	$tabs = null;

	constructor( $container ) {
		if ( ! $container?.length ) {
			return;
		}

		this.$container = $container;

		this.initTabs();
	}

	initTabs() {
		const self = this,
			$wrapper = this.$container;

		this.$tabs = $wrapper.find( '.tabs' ).find( '.tab' );
		this.$tabAnchors = $wrapper
			.find( '.tab-anchors' )
			.find( 'a.tab-anchor' );

		this.$tabAnchors.on( 'click', function ( ev ) {
			const tabAnchor = $( this );

			ev.preventDefault();

			self.onTabChange( tabAnchor.data( 'tab' ) );
		} );

		this.onTabChange( this.$tabAnchors.first().data( 'tab' ) );
	}

	onTabChange( tab ) {
		const $tab = this.$tabs.filter( `#${ tab }` );

		if ( ! $tab.length ) {
			return false;
		}

		const $tabAnchor = this.$tabAnchors.filter( `[data-tab="${ tab }"]` ),
			$modeField = this.$container.find( '#mode' );

		if ( $tabAnchor.length ) {
			this.$tabAnchors.removeClass( 'active' );
			$tabAnchor.addClass( 'active' );
		}

		this.$tabs.removeClass( 'active' );
		$tab.addClass( 'active' );

		if ( $modeField?.length ) {
			$modeField.val( tab );
		}
	}
}
